import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {
  "language": "UA",
  "name": "Угорщина",
  "title": "modal-2-3-1-3"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 tabIndex="0">Революція в Угорщині</h2>
    <p tabIndex="0">Поразка в Першій світовій війні дискредитувала династію Габсбургів і привела до розпаду Австро-Угорщини. Восени 1918 року в Угорщині і Австрії відбулася революція, в результаті якої імператор і король були усунені від влади. Комуністи, відправлені до Угорщини з Москви, намагалися захопити владу в Угорщині вже в лютому 1919 року, але спроба перевороту не вдалася. Вони прийшли до влади тільки 21 березня 1919 року в умовах компрометації президента Міхая Карої і уряду Денеша Берінкеї. Того дня разом з соціал-демократами вони створили <strong>Угорську радянську республіку</strong> під керівництвом <strong>Бели Куна</strong>. У країні запанував «червоний терор» за зразком того, який більшовики встановили в Росії. Однією з ініціатив комуністів було створення озброєних загонів для боротьби з контрреволюцією - <strong>«Ленінців»</strong>. Угорським комуністам також вдалося на короткий час створити <strong>Словацьку радянську республіку</strong>. На початку серпня 1919 року добігло кінця існування УСР - румунська армія, яка співпрацювала з Антантою, зайняла велику частину території разом з Будапештом. Після падіння комуністичного правління влада перейшла в руки адм. Міклоша Горті і украй правого уряду, які репресували представників попереднього режиму.
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      